import type { ActiveAISessionStage } from '@/stores/uiStore';

export function shouldClearInactiveSnapshotStage({
  workflowWorkspaceVisible,
  activeStage,
  knownSessionId,
}: {
  workflowWorkspaceVisible: boolean;
  activeStage: ActiveAISessionStage | null | undefined;
  knownSessionId?: string | null;
}): boolean {
  if (
    workflowWorkspaceVisible ||
    !activeStage ||
    activeStage.skipHydration ||
    (activeStage.type !== 'asset_breakdown' && activeStage.type !== 'storyboard_breakdown')
  ) {
    return false;
  }
  return !(knownSessionId && knownSessionId === activeStage.sessionId);
}
